import React from "react";
import Select from "react-select";
import Option from "./option";
import DropdownIndicator from "./dropdown-indicator";
import { array, string, func, shape, bool } from "prop-types";

const groupStyles = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
};

const formatGroupLabel = (data) => (
  <div style={groupStyles}>
    <span>{data.label}</span>
  </div>
);

/**
 * Custom styles to change the look and feel of the react select components
 */
const customStyles = {
  valueContainer: (provided, state) => ({
    ...provided,
    textOverflow: "ellipsis",
    maxWidth: "150px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    display: "initial",
    borderRadius: "8px",
    textTransform: "capitalize",
    backgroundColor: state.hasValue ? "#0627F3" : "#FFFFFF",
    color: "#fff",
    fontWeight: "400",
    fontSize: "12px",
    textAlign: "center",
    paddingLeft: "10px",
  }),
  control: (base, state) => ({
    ...base,
    borderRadius: state.isFocused ? "3px 3px 0 0" : 3,
    backgroundColor: "#fff",
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    border: "none",
    boxShadow: "none",
    outline: "none",
    float: "right",
    width: "100%",
  }),
  menu: (base, state) => ({
    ...base,
    borderRadius: 8,
    marginTop: "45px",
    zIndex: 9999999,
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected ? "#F8F9FF" : "#FFFF",
    borderRadius: "8px",
    "&:hover": {
      backgroundColor: state.isSelected ? "" : "#F8F9FF",
      color: "#000",
    },
  }),
  menuList: (base) => ({
    ...base,
    padding: 0,
    maxHeight: "200px",
  }),
  dropdownIndicator: (base, state) => ({
    ...base,
    transform: state.selectProps.menuIsOpen ? "rotate(90deg)" : "rotate(0)",
    transition: "250ms",
  }),
};

/**
 * Update the way the multiple selected items are displayed
 */

const multiValueContainer = ({ selectProps, data }) => {
  const label = data.label;
  const allSelected = selectProps.value;
  const index = allSelected.findIndex((selected) => selected.label === label);
  const isLastSelected = index === allSelected.length - 1;
  const labelSuffix = isLastSelected ? ` ` : ", ";
  const val = `${label}${labelSuffix}`;
  return val;
};

export const MultiSelect = ({
  options,
  field = {
    value: undefined,
    onChange: () => {},
    onBlur: () => {},
    name: "",
    ref: () => {},
    isDisabled: false,
  },
  isDisabled,
}) => {
  return (
    <span data-toggle="popover" data-trigger="focus">
      <Select
        options={options}
        isMulti
        components={{
          // replace the way the multiple values
          // are displayed component with a custom one
          MultiValueContainer: multiValueContainer,
          // replace the option component with a custom one
          Option,
          // remove the separator
          IndicatorSeparator: () => null,
          // replace the dropdown indicator with a custom one
          DropdownIndicator,
        }}
        formatGroupLabel={formatGroupLabel}
        closeMenuOnSelect={false}
        hideSelectedOptions={false}
        styles={customStyles}
        isSearchable={false}
        {...field}
        placeholder=""
        isClearable={true}
        isDisabled={isDisabled}
      />
    </span>
  );
};

MultiSelect.propTypes = {
  options: array.isRequired,
  isDisabled: bool.isRequired,
  field: shape({
    value: array,
    onChange: func,
    onBlur: func,
    ref: func,
    name: string,
  }),
};

export default MultiSelect;
